/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://my186vzjwe.execute-api.us-east-1.amazonaws.com/devsix",
            "region": "us-east-1"
        },
        {
            "name": "restapi",
            "endpoint": "https://0614f1c1d9.execute-api.us-east-1.amazonaws.com/devsix",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://k647lvhz25fyxgtg6ojbyosjvm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:a44ce3a8-853e-4dba-8af9-1f62d8248dd8",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Kfkox0QIf",
    "aws_user_pools_web_client_id": "6r2qni802asi6qf234fbqic09d",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "babtl-20240101215828-hostingbucket-devsix",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2nuf6rals8nt9.cloudfront.net"
};


export default awsmobile;
